import { COLOR } from 'src/app/utils/theme.utils';

export enum SafeAreaBarStyle {
  Dark = 'dark',
  Light = 'light',
}

export type SafeAreaConfig = {
  statusBarColor: COLOR;
  navigationBarColor: COLOR;
  barStyle: SafeAreaBarStyle;
};